// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
import type { IGetPromoBannersRequest, TGetPromoBannersModel, IMappers, TGetPromoBannersResponse } from './types';
import type { IHttpApi, IHttpApiFetchConfig, FetchResponse } from '@cian/http-api';
import type { IV1GetPromoBannersResponseSchema } from '../../entities/get_promo_banners/V1GetPromoBannersResponseSchema';
import type { IErrorResponseSchema } from '../../entities/schemas/ErrorResponseSchema';

export function createGetPromoBannersModel(parameters: IGetPromoBannersRequest): TGetPromoBannersModel {
  return {
    v: 1,
    apiType: 'public',
    method: 'GET',
    microserviceName: 'newbuilding-promos',
    pathApi: '/v1/get-promo-banners/',
    response: {
      200: {
        contentType: 'json',
      },
      400: {
        contentType: 'json',
      },
    },
    request: {
      parameters,
    },
  };
}

export interface IGetPromoBannersOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
  parameters: IGetPromoBannersRequest;
}

export async function fetchGetPromoBanners<TResponse200, TResponse400>({
  httpApi,
  config,
  mappers,
  parameters,
}: IGetPromoBannersOptions<TResponse200, TResponse400>): Promise<
  FetchResponse<TGetPromoBannersResponse> | TResponse200 | TResponse400
> {
  const { statusCode, response, headers } = (await httpApi.fetch(
    createGetPromoBannersModel(parameters),
    config,
  )) as FetchResponse<TGetPromoBannersResponse>;
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as IV1GetPromoBannersResponseSchema, headers);
    }
    if (statusCode === 400) {
      return mappers[400](response as IErrorResponseSchema, headers);
    }
  }

  return {
    statusCode,
    response,
    headers,
  } as FetchResponse<TGetPromoBannersResponse>;
}
